import { useState, useMemo, useEffect } from "react";

import Dialog from "@mui/material/Dialog";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import OutlinedInput from "@mui/material/OutlinedInput";
import IconButton from "@mui/material/IconButton";
import FormControl, { useFormControl } from "@mui/material/FormControl";

import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";

import { useGetUserQuery } from "../user/userApiSlice";
import { useAddNewLabelMutation, useGetLabelsQuery } from "./labelsApiSlice";
import EditLabelsList from "./EditLabelsList";

function AddNewLabelBtn(props) {
  const { filled } = useFormControl() || {};
  const addBtn = useMemo(() => {
    return filled && <AddOutlinedIcon />;
  }, [filled]);

  return (
    <div>
      <Button
        sx={{ ml: 2 }}
        aria-label="add"
        size="large"
        startIcon={addBtn}
        onClick={() => props.onAddClick()}
      />
    </div>
  );
}
function EditLabelsForm(props) {
  const { onClose, open, ...other } = props;
  const [newLabel, setNewLabel] = useState("");
  const { data: labels, isSuccess } = useGetLabelsQuery("labelsList", {
    pollingInterval: 60000,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });
  //const { data: author } = useSelector(selectUserResult);
  const { data: author } = useGetUserQuery("User");
  const [
    addNewLabel,
    {
      isSuccess: isAddSuccess,
      isError: isAddError,
      error: errorAdd,
      reset: resetAdd,
    },
  ] = useAddNewLabelMutation();
  let helperText = "";
  async function onAddNewLabelClicked() {
    await addNewLabel({
      name: newLabel,
      author_id: author._id,
    });
  }

  function handleDone() {
    onClose();
  }
  function handleClearClick() {
    setNewLabel("");
    helperText = "";
    resetAdd();
  }

  if (isAddError) {
    helperText = <p className="errmsg">{errorAdd?.data?.message}</p>;
  }
  useEffect(() => {
    if (isAddSuccess) {
      setNewLabel("");
      resetAdd();
    }
  }, [isAddSuccess, resetAdd]);
  let content;
  if (isSuccess) {
    const { ids } = labels;

    content = (
      <Dialog //maxWidth: "365px"
        fullWidth={true}
        sx={{ "& .MuiDialog-paper": { width: "28%", maxWidth: "365px", p: 1 } }}
        //TransitionProps={{ onEntering: handleEntering }}
        open={open}
        onClose={onClose}
      >
        <DialogTitle>Edit Labels</DialogTitle>
        <DialogContent dividers>
          <FormControl>
            <Stack direction={"row"}>
              <IconButton
                sx={{ visibility: newLabel ? "visible" : "hidden" }}
                onClick={handleClearClick}
              >
                <ClearOutlinedIcon />
              </IconButton>
              <OutlinedInput
                className="edit-outlined"
                maxwidth="100%"
                placeholder="Enter New Label"
                id="newLabel"
                name="newLabel"
                type="text"
                size="small"
                value={newLabel}
                onChange={(e) => {
                  setNewLabel(e.target.value);
                }}
              />
              <AddNewLabelBtn
                label={newLabel}
                onAddClick={onAddNewLabelClicked}
              />
            </Stack>
            {helperText}
          </FormControl>
          {ids?.map((labelId, i) => (
            <EditLabelsList key={i} labelId={labelId} />
          ))}
        </DialogContent>
        <DialogActions>
          <Button sx={{ pr: 4.5 }} autoFocus onClick={handleDone}>
            Done
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  return content;
}

export default EditLabelsForm;
